import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export interface LoaderState {
  loading: boolean;
  showGenericSpinner: boolean;
  loadingMessageKey: string;
}

@Injectable({
  providedIn: 'root',
})
export class LoaderService {
  private loadingCount = 0;
  private loaderStateSubject = new BehaviorSubject<LoaderState>({
    loading: false,
    showGenericSpinner: false,
    loadingMessageKey: '',
  });;

  getLoading() {
    return this.loaderStateSubject.asObservable();
  }

  show(showGenericSpinner?: boolean, loadingMessageKey?: string) {
    this.loadingCount++;
    this.loaderStateSubject.next({
      loading: true,
      showGenericSpinner: showGenericSpinner ?? false,
      loadingMessageKey: loadingMessageKey ?? "",
    });
  }
  hide() {
    if (this.loadingCount > 0) {
      this.loadingCount--;
    }

    if (this.loadingCount === 0) {
      this.loaderStateSubject.next({
        loading: false,
        showGenericSpinner: false,
        loadingMessageKey: '',
      });
    }
  }
}
